// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","textDefault":"#808080","container":"_2eERDnTPBg5ZKNoIpJ9gw","text":"_2qu6DkTeJSyd1CX3LcHFZa","label":"_2-WBgGUUS1K5cU_I_KZgdH","button-section":"_2bC3RJDn-BrvMfbgV_vYGB"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/UserProfile/UserProfileSupport.mod.css
// module id = 595
// module chunks = 0